import React, {Component} from 'react';
import {connect} from 'react-redux';

import BasicFrame from './frames/BasicsFrame';
import RentalHistoryFrame from './frames/RentalHistoryFrame';
import EmploymentFrame from './frames/EmploymentFrame';
import GeneralFrame from './frames/GeneralFrame';
import SummaryFrame from './frames/Summary';
import CreditFrameContainer from './frames/CreditFrameContainer';
import PolyUtil from "../../../util/PolyUtil";
import VehicleFrame from "./frames/VehicleFrame";
import BioFrame from './frames/BioFrame';
import PolyFlowNavigator from "../../../components/flow/PolyFlow/PolyFlowNavigator";
import PolyFlowNavItem from "../../../components/flow/PolyFlow/PolyFlowNavItem";
import PolyFlowContainer from "../../../components/flow/PolyFlow/PolyFlowContainer";
import PolyFlowNavContainer from "../../../components/flow/PolyFlow/PolyFlowNavContainer";
import PolyFlowBottomBar from "../../../components/flow/PolyFlow/PolyFlowBottomBar";
import {setFooterVisibility} from "../../navigation/actions/navbar";

class TenantApplicationContainer extends Component {

    componentWillMount() {
        this.props._setFooterVisibilty(false);
    }

    componentWillUnmount() {
        this.props._setFooterVisibilty(true);
    }

    render() {
        const {application, tuVerified} = this.props;

        const appComplete = application.application_percent_complete === 100;

        return (
            <div className="mb-3">
                <PolyFlowNavigator id="tenant_application">
                    <PolyFlowNavItem filled={application.is_basic_complete} label="Basics"/>
                    <PolyFlowNavItem filled={PolyUtil.validArr(application.rental_history_rentals)} label="Rental History"/>
                    <PolyFlowNavItem filled={PolyUtil.validArr(application.employment_history_positions)} label="Employment"/>
                    <PolyFlowNavItem filled={application.is_advanced_complete} label="General"/>
                    <PolyFlowNavItem filled={application.is_vehicle_complete} label="Vehicle"/>
                    <PolyFlowNavItem filled={application.is_bio_complete} label="Bio"/>
                    <PolyFlowNavItem filled={(!application.skip_guarantor && application.guarantor) || tuVerified} disabled={application.application_percent_complete < 83} label="Credit"/>
                    <PolyFlowNavItem filled={appComplete} label="Summary"/>
                </PolyFlowNavigator>

                <PolyFlowContainer id="tenant_application" wrapper={PolyFlowNavContainer} defaultFlowKey={appComplete && 7}>
                    <BasicFrame/>
                    <RentalHistoryFrame/>
                    <EmploymentFrame/>
                    <GeneralFrame/>
                    <VehicleFrame/>
                    <BioFrame/>
                    <CreditFrameContainer/>
                    <SummaryFrame/>
                </PolyFlowContainer>

                <PolyFlowBottomBar id="tenant_application" hideOnLast formNames={[
                    'application_basic',
                    ['application_rental_history', 'application_edit_rental_history'],
                    ['application_employment_history', 'application_edit_employment_history'],
                    'application_general',
                    'application_vehicle',
                    'application_bio',
                    null,
                    null,
                ]}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    application: state.tenant.application,
    tuVerified: state.tenant.idmaStatus === 'Verified'
});

const mapDispatchToProps = (dispatch) => ({
    _setFooterVisibilty(visible) {
        return dispatch(setFooterVisibility(visible));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TenantApplicationContainer);


// WEBPACK FOOTER //
// ./src/containers/tenant/application/TenantApplicationContainer.js